export default __webpack_public_path__ + "static/media/151-closing.653945d7.png";